import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"

import qrCodeImg from 'assets/images/qr_code.png'
import qrCodeHoverImg from 'assets/images/qr_code_hover.png'
// import { ReactComponent as QrCodeSvg } from 'assets/svgs/qr_code.svg'
import { ReactComponent as TwitterSvg } from 'assets/svgs/contact_twitter.svg'
import { ReactComponent as TelegramSvg } from 'assets/svgs/contact_telegram.svg'
import { ReactComponent as MediumSvg } from 'assets/svgs/contact_medium.svg'
import { ReactComponent as YoutubeSvg } from 'assets/svgs/contact_youtube.svg'
import { useState } from "react"
import { ColumnCenter, Row } from "style/preset"
import { checkMobile } from "utils"

const BottomCom = () => {
    const [hoverImg, setHoverImg] = useState(qrCodeImg)
    const fnHoverEnter = () => {
        setHoverImg(qrCodeHoverImg)
    }

    const fnHoverLeave = () => {
        setHoverImg(qrCodeImg)
    }

    const fnOpenWin = (url: string) => {
        window.open(url, '_blank')
    }

    return <BottomWrap>
        <HoverWrap onMouseOver={fnHoverEnter} onMouseLeave={fnHoverLeave}>
            <QrCode src={hoverImg}></QrCode>
            <DownLabel>Download Mobile App</DownLabel>
            {/* <DownLabel>Chainge App</DownLabel> */}
        </HoverWrap>
        <StyledContainer $height="30px"></StyledContainer>
        <ContactUsCom></ContactUsCom>
        <StyledContainer $height="24px"></StyledContainer>
        <CopyrightBoxWrap>
            <CopyrightInfoWrap>© 2024 Chainge</CopyrightInfoWrap>
            <Row>
                <CopyrightInfoWrap $pointer $hover="text-decoration: underline;" onClick={() => fnOpenWin('https://fathomlaw.app.box.com/s/bwui2utfymvzzt16na3qi1vpgrkcvftu')}>Terms</CopyrightInfoWrap>
                <StyledContainer $width="5px"></StyledContainer>
                <CopyrightInfoWrap $pointer $hover="text-decoration: underline;" onClick={() => fnOpenWin('https://fathomlaw.box.com/s/1zlappp8e41bfyhni3iasom0lh93hmqn')}>Privacy Policy</CopyrightInfoWrap>
            </Row>
            <VersionInfoWrap $mt="4px" $mb="30px">Version 2.1.1</VersionInfoWrap>
        </CopyrightBoxWrap>
    </BottomWrap>
}

export const ContactUsCom = () => {
    const openLink = (type: string) => {
        let tempLink = "";
        switch (type) {
          case "twitter":
            tempLink = "https://twitter.com/FinanceChainge";
            break;
          case "tg":
            tempLink = "https://t.me/chaingefinance";
            break;
          case "medium":
            tempLink = "https://medium.com/@chainge-finance";
            break;
          case "linktree":
            tempLink = "https://linktr.ee/Chainge.Finance";
            break;
          default:
            tempLink = "https://www.youtube.com/@ChaingeFinance";
        }
        window.open(tempLink, "_blank");
    };
    return <ContactUsWrap $isMobile={checkMobile()}>
        <TwitterSvgWrap onClick={() => openLink('twitter')}></TwitterSvgWrap>
        <TelegramSvgWrap onClick={() => openLink('tg')}></TelegramSvgWrap>
        <MediumSvgWrap onClick={() => openLink('medium')}></MediumSvgWrap>
        <YoutubeSvgWrap onClick={() => openLink('youtube')}></YoutubeSvgWrap>
    </ContactUsWrap>
}

const BottomWrap = styled(StyledContainer)`
    background-color: ${({theme}) => theme.lightGrey};
    border-top: 1px dashed ${({theme}) => theme.leftBarBorder}; 

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const QrCode = styled.img`
    width: 70px;
    height: 70px;
    margin-top: 30px;
    margin-bottom: 12px;
`

const DownLabel = styled(StyledContainer)`
    font-size:12px;
    line-height: 16px;
    font-family: RoobertSemiBold;
`

const HoverWrap = styled(StyledContainer)`
    text-align: center;
    cursor: pointer;

    &:hover {
        ${DownLabel} {
            text-decoration: underline;
        }
    }
`

const SvgWrapStyle = () => {
    return css`
        width: 16px;
        height: 16px;
        cursor: pointer;
        &:hover {
            path, rect {
                fill: #0a0a0a;
            }
        }
    `
}


const TwitterSvgWrap = styled(TwitterSvg)`
    ${SvgWrapStyle()}
`
const TelegramSvgWrap = styled(TelegramSvg)`
    ${SvgWrapStyle()}
`
const MediumSvgWrap = styled(MediumSvg)`
    ${SvgWrapStyle()}
`
const YoutubeSvgWrap = styled(YoutubeSvg)`
    ${SvgWrapStyle()}
`

const ContactUsWrap = styled(StyledContainer)<{$isMobile: boolean}>`
    display: flex;
    justify-content: center;
    align-items: center;
   
    ${TwitterSvgWrap}, ${TelegramSvgWrap}, ${MediumSvgWrap} {
        margin-right: 12px;
    }
    ${
        ({$isMobile}) => $isMobile ? css`

        ` : css`
            @media screen and (max-width: 1024px) {
                flex-wrap: wrap;
                width: 44px;
        
                ${TwitterSvgWrap} {
                    margin-right: 12px;
                    margin-bottom: 12px;
                }
        
                ${TelegramSvgWrap} {
                    margin: 0;
                    margin-bottom: 12px;
                }
            }
        `
    }
`

const CopyrightInfoWrap = styled(StyledContainer)`
    font-size: 12px;
    line-height: 16px;
    color: ${({theme}) => theme.deepGrey};   
    font-family: RoobertRegular;
`

const VersionInfoWrap = styled(StyledContainer)`
    font-size: 12px;
    line-height: 1;
    color: ${({theme}) => theme.lightBlack}; 
    font-family: RoobertSemiBold;
`

const CopyrightBoxWrap = styled(ColumnCenter)`
    @media screen and (min-width: 1024px) {
        display: flex;
    }
    @media screen and (max-width: 1024px) {
        display: none;
    }
`

export default BottomCom